import React, { useCallback } from 'react'
import Layout from '../layout/Layout'
import { observer } from "mobx-react-lite"
import { useNavigate } from "@reach/router"

import classes from './styles.module.scss'


const BaseLayout = observer(({children}) => {
  const navigate = useNavigate();

  const handleRoute = useCallback((e) => {
    e.preventDefault()
    //console.log(e.target.getAttribute('href'))
    navigate(e.target.getAttribute('href'))
  }, [navigate])

  return <Layout className={classes.policies}>
        <div className={classes.container}>
          <div className={classes.content}>
            <div className={classes['index']}>
                <ul>
                    <li><a href='/policies/pricing-terms' onClickCapture={handleRoute}>Pricing Terms</a></li>
                    <li><a href='/policies/terms-of-service' onClickCapture={handleRoute}>Terms of Service</a></li>
                    <li><a href='/policies/privacy-policy' onClickCapture={handleRoute}>Privacy Policy</a></li>
                    <li><a href='/policies/acceptable-use-and-fair-usage-policy' onClickCapture={handleRoute}>Acceptable Use and Fair Usage Policy</a></li>
                    <li><a href='/policies/copyrights' onClickCapture={handleRoute}>Copyrights</a></li>
                </ul>
            </div>
            {children}
          </div>
        </div>
  </Layout>
})

export default BaseLayout